import { get, patch, httpDelete } from 'store/http/httpAction';
import {
  SETUP_WORKFLOW, UPDATE_WORKFLOW_STATUS,
  SETUP_WORKFLOW_PAGENATION,
  SETUP_WORKFLOW_ACTION_LOG,
  SETUP_WORKFLOW_ACTION_PAGENATION,
  SETUP_WORKFLOW_FAILURE_LOG,
  SETUP_WORKFLOW_FAILURE_PAGENATION
} from './actionType';

const setWorkFlow = workflows => ({
  type: SETUP_WORKFLOW,
  payload: { workflows }
});

const setPagination = (perPage, currentPage, total) => ({
  type: SETUP_WORKFLOW_PAGENATION,
  payload: {
    perPage,
    currentPage,
    total,
  }
});

const setWorkFlowStatus = updatedWorkflow => ({
  type: UPDATE_WORKFLOW_STATUS,
  payload: {
    id: updatedWorkflow.id,
    is_active: updatedWorkflow.is_active,
  }
});

export const fetchWorkflows = (perPage, currentPage = 1) => dispatch => get('/admin/workflow-rules', { per_page: perPage, page: currentPage }, dispatch).then(data => {
  if (!_.isEmpty(data) && !_.isEmpty(data.data) && !_.isEmpty(data.meta)) {
    dispatch(setWorkFlow(data.data));

    const { pagination } = data.meta;
    const { per_page, current_page, total } = pagination;
    dispatch(setPagination(per_page, current_page, total));
  }
});

export const updateWorkflowStatus = (id, status) => dispatch => patch(`/admin/workflow-rules/${id}`, { is_active: status }, dispatch).then(data => {
  if (!_.isEmpty(data) && !_.isEmpty(data.data)) {
    dispatch(setWorkFlowStatus(data.data));
  }
});

export const deleteWorkflow = (id, cb) => dispatch => httpDelete(`/admin/workflow-rules/${id}`, {}, dispatch).then((data) => {
  if (!_.isEmpty(data) && _.isFunction(cb)) {
    cb();
  }
});

// Log Section
const setWorkflowActionLogs = actionLogs => ({
  type: SETUP_WORKFLOW_ACTION_LOG,
  payload: { actionLogs }
});

const setActionPagination = (perPage, currentPage, total) => ({
  type: SETUP_WORKFLOW_ACTION_PAGENATION,
  payload: {
    perPage,
    currentPage,
    total,
  }
});

const setWorkflowFailureLogs = failureLogs => ({
  type: SETUP_WORKFLOW_FAILURE_LOG,
  payload: { failureLogs }
});

const setFailurePagination = (perPage, currentPage, total) => ({
  type: SETUP_WORKFLOW_FAILURE_PAGENATION,
  payload: {
    perPage,
    currentPage,
    total,
  }
});

export const fetchWorkflowActionLogs = (perPage, currentPage = 1) => dispatch => get('/admin/workflow-action-logs', { per_page: perPage, page: currentPage }, dispatch).then(data => {
  if (!_.isEmpty(data) && !_.isEmpty(data.data) && !_.isEmpty(data.meta)) {
    dispatch(setWorkflowActionLogs(data.data));

    const { pagination } = data.meta;
    const { per_page, current_page, total } = pagination;
    dispatch(setActionPagination(per_page, current_page, total));
  }
});

export const fetchWorkflowFailureLogs = (perPage, currentPage = 1) => dispatch => get('/admin/workflow-rule-process-failure-logs', { per_page: perPage, page: currentPage }, dispatch).then(data => {
  if (!_.isEmpty(data) && !_.isEmpty(data.data) && !_.isEmpty(data.meta)) {
    dispatch(setWorkflowFailureLogs(data.data));

    const { pagination } = data.meta;
    const { per_page, current_page, total } = pagination;
    dispatch(setFailurePagination(per_page, current_page, total));
  }
});



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/flow/action.js